import styled from 'styled-components';
import {
  ClientOnlyModal,
  ModalProps,
} from '@pass-frontend/common/components/modal/ui';
import { STANDALONE_PATHS } from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';
import { ServiceSectorName } from '@pass-frontend/data-access/common/edge';
import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

export interface MemberCodeFoundModalProps {
  onRequestedClose: ModalProps['onRequestedClose'];
  isOpen: ModalProps['isOpen'];
  memberCode?: string;
  serviceSector?: string;
}

const StyledMemberFoundModal = styled(ClientOnlyModal)`
  border-radius: 17px;

  &.modal {
    width: calc(100% - 32px);
    height: auto;
    margin: 16px;
    padding-bottom: 16px;

    ${MEDIA_QUERY.desktop} {
      width: 600px;
      padding: 40px;
    }
  }

  .body {
    margin: 24px 0 0 0;
  }

  .close-btn {
    border: none;
    color: #222222;
    margin-bottom: 24px;

    .system-close {
      height: 14px;
      width: 14px;
    }
  }
`;

const ModalBody = styled.p`
  margin-bottom: 40px;

  .member-code {
    margin-bottom: 24px;
  }

  .modal-content-body-one {
    margin-bottom: 16px;
  }

  ${MEDIA_QUERY.mobile} {
    margin-bottom: 24px;

    .member-code {
      margin-bottom: 16px;
    }
  }
`;

const ModalTitle = styled.h1.attrs({
  className: 'is-display-flex is-h3 has-text-blue-1',
})`
  margin: 24px 0;

  ${MEDIA_QUERY.mobile} {
    margin: 16px 0;
  }
`;

const BackButton = styled.a.attrs({
  className: 'is-display-flex is-justify-content-end',
})`
  button {
    ${MEDIA_QUERY.mobile} {
      width: 100%;
      height: 32px;
      padding: 6px 0;
    }
  }

  &:hover {
    text-decoration: none;
  }
`;

export function MemberCodeFoundModal(props: MemberCodeFoundModalProps) {
  const { t } = useIntl();
  const { serviceSector, memberCode, ...modalConfig } = props;
  const isServiceSectorGovernment =
    serviceSector === ServiceSectorName.Government;

  return (
    <StyledMemberFoundModal
      data-testid="member-code-found"
      ariaHeadingId="member-code-found"
      ariaLabel={t('memberCodeFoundModal.title')}
      overlayZIndex={1001}
      shouldHideHeading={true}
      className="modal"
      {...modalConfig}
    >
      <>
        {isServiceSectorGovernment && (
          <>
            <ModalTitle>{t('memberCodeFoundModal.title')}</ModalTitle>
            <ModalBody className="is-body-2-regular">
              <div className="is-h4 has-text-gray-1 member-code">
                {memberCode}
              </div>
              <div className="modal-content-body-one">
                {t('memberCodeFoundModal.bodyOne')}
              </div>
            </ModalBody>
          </>
        )}
        {serviceSector === ServiceSectorName.Commercial && (
          <>
            <ModalTitle>{t('memberCodeFoundModal.title')}</ModalTitle>
            <ModalBody className="is-body-2-regular">
              {t('memberCodeFoundModal.body')}
            </ModalBody>
          </>
        )}
        <BackButton href={STANDALONE_PATHS.DASHBOARD}>
          <button
            type="button"
            className="btn has-bg-blue-1 has-text-white is-body-1-bold "
          >
            {t('memberCodeFoundModal.backToHome')}
          </button>
        </BackButton>
      </>
    </StyledMemberFoundModal>
  );
}
